import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import useIban from '@/containers/SubscriptionFormPageNew/Components/Billing/Fields/useIban'

const useIbanVerifier = () => {
  const { t } = useTranslation()
  const [iban, setIban] = useState('')
  const { ibanValidationHandler, bankInformation, ibanIsLoading, validationResponse } = useIban(() => {})

  const cleanedIban = (iban ?? '').replace(/\s/g, '')
  const canVerify = cleanedIban.length > 0 && !ibanIsLoading

  const verifyIban = event => {
    event.preventDefault()
    ibanValidationHandler(cleanedIban)
  }

  return {
    t,
    iban,
    setIban,
    canVerify,
    verifyIban,
    ibanIsLoading,
    bic: bankInformation?.bic ?? '',
    error: validationResponse?.error,
  }
}

export default useIbanVerifier
